import { render, staticRenderFns } from "./TibBannerTitleInput.vue?vue&type=template&id=8b2923e4"
import script from "./TibBannerTitleInput.vue?vue&type=script&lang=js"
export * from "./TibBannerTitleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports